import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../components/ui/Card';
import { Target, Eye, Heart, Shield } from 'lucide-react';
const team = [{
  name: 'Dr. Robert Wilson',
  role: 'Founder & CEO',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  bio: '20+ years in international education.'
}, {
  name: 'Sarah Mitchell',
  role: 'Head of Admissions',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  bio: 'Expert in UK and US university systems.'
}, {
  name: 'David Kim',
  role: 'Senior Counselor',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  bio: 'Specialist in visa guidance and compliance.'
}, {
  name: 'Elena Rodriguez',
  role: 'Student Support Lead',
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  bio: 'Dedicated to student welfare and settlement.'
}];
export function AboutPage() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="pt-20" data-id="element-237">
      {/* Hero Banner */}
      <div className="bg-[#1e3a5f] text-white py-20" data-id="element-238">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-239">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-240">
            About Study Board
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-241">
            Bridging the gap between ambitious students and world-class
            education since 2010.
          </p>
        </div>
      </div>

      {/* Mission & Vision */}
      <section className="py-20 bg-white" data-id="element-242">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-243">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-244">
            <Card className="p-8 border-l-4 border-[#f59e0b]" data-id="element-245">
              <div className="flex items-center mb-4" data-id="element-246">
                <Target className="h-8 w-8 text-[#f59e0b] mr-3" data-id="element-247" />
                <h2 className="text-2xl font-bold text-[#1e3a5f]" data-id="element-248">
                  Our Mission
                </h2>
              </div>
              <p className="text-gray-600 leading-relaxed" data-id="element-249">
                To empower students globally by providing transparent, accurate,
                and personalized guidance for international education, making
                the complex process of studying abroad simple and accessible to
                all.
              </p>
            </Card>
            <Card className="p-8 border-l-4 border-[#1e3a5f]" data-id="element-250">
              <div className="flex items-center mb-4" data-id="element-251">
                <Eye className="h-8 w-8 text-[#1e3a5f] mr-3" data-id="element-252" />
                <h2 className="text-2xl font-bold text-[#1e3a5f]" data-id="element-253">
                  Our Vision
                </h2>
              </div>
              <p className="text-gray-600 leading-relaxed" data-id="element-254">
                To be the world's most trusted education consultancy, recognized
                for our integrity, student-centric approach, and high success
                rate in placing students in their dream universities.
              </p>
            </Card>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-[#faf8f5]" data-id="element-255">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-256">
          <div className="text-center mb-16" data-id="element-257">
            <h2 className="text-3xl font-bold text-[#1e3a5f] mb-4" data-id="element-258">
              Our Core Values
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-259">
            <div className="text-center" data-id="element-260">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-261">
                <Shield className="h-8 w-8 text-blue-600" data-id="element-262" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-263">Integrity</h3>
              <p className="text-gray-600" data-id="element-264">
                We operate with complete transparency and honesty in all our
                dealings.
              </p>
            </div>
            <div className="text-center" data-id="element-265">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-266">
                <Heart className="h-8 w-8 text-amber-600" data-id="element-267" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-268">Student First</h3>
              <p className="text-gray-600" data-id="element-269">
                Every decision we make is based on what is best for the
                student's future.
              </p>
            </div>
            <div className="text-center" data-id="element-270">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-271">
                <Target className="h-8 w-8 text-green-600" data-id="element-272" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-273">Excellence</h3>
              <p className="text-gray-600" data-id="element-274">
                We strive for excellence in our services and student outcomes.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-white" data-id="element-275">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-276">
          <div className="text-center mb-16" data-id="element-277">
            <h2 className="text-3xl font-bold text-[#1e3a5f] mb-4" data-id="element-278">
              Meet Our Team
            </h2>
            <p className="text-gray-600" data-id="element-279">The experts behind your success</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-280">
            {team.map(member => <Card key={member.name} noPadding className="text-center overflow-hidden group" data-id="element-281">
                <div className="h-64 overflow-hidden" data-id="element-282">
                  <img src={member.image} alt={member.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-283" />
                </div>
                <div className="p-6" data-id="element-284">
                  <h3 className="text-lg font-bold text-[#1e3a5f]" data-id="element-285">
                    {member.name}
                  </h3>
                  <p className="text-[#f59e0b] font-medium text-sm mb-2" data-id="element-286">
                    {member.role}
                  </p>
                  <p className="text-gray-500 text-sm" data-id="element-287">{member.bio}</p>
                </div>
              </Card>)}
          </div>
        </div>
      </section>
    </motion.div>;
}